// src/services/customerReturnService.js
import ApiService from './api'

class CustomerReturnService {
  /**
   * Get all customer return orders
   * @param {Object} params - Query parameters for filtering
   * @returns {Promise} API response
   */
  async getAllCustomerReturns(params = {}) {
    try {
      console.log('📋 Fetching customer returns with params:', params)
      
      const response = await ApiService.get('/order-returns', params)
      console.log('✅ Customer returns fetched successfully:', response)
      return response
    } catch (error) {
      console.error('❌ Error fetching customer returns:', error)
      
      // Return mock data if API is not available
      if (error.response?.status === 404 || error.message?.includes('Network Error')) {
        console.warn('Customer returns API not available, returning mock data')
        return {
          success: true,
          statusCode: 200,
          message: 'Order returns retrieved successfully (mock data)',
          data: {
            orderReturns: [
              {
                _id: '68c2a6b78667d4d21d661f29',
                order: {
                  _id: '68c2a6168667d4d21d661dd6',
                  orderNumber: 'ORD06766737001',
                  branch: {
                    _id: '68ab4a5075017ad6d7d8ad53',
                    name: 'Tezlaa Colombo',
                    type: 'outlet',
                    address: 'Colombo 5',
                    phoneNumber: '1234567895',
                    email: 'abc@gmail.com'
                  },
                  customer: {
                    _id: '68ac4a2433f0e932f040a32c',
                    name: 'Walking Customer',
                    mobileNumber: '0000000000'
                  },
                  orderType: 'dine_in',
                  orderStatus: 'completed',
                  paymentStatus: 'paid'
                },
                branch: '68ab4a5075017ad6d7d8ad53',
                returnType: 'customer',
                restockableStatus: true,
                refundMethod: 'cash',
                items: [
                  {
                    product: {
                      _id: '68ab4e4475017ad6d7d8af76',
                      name: 'Blueberry Muffin',
                      sku: 'PC001',
                      category: '68ab4e1575017ad6d7d8af49',
                      cost: 125,
                      outletPrice: 250
                    },
                    returnQuantity: 2,
                    unitPrice: 250,
                    discountPerUnit: 25,
                    finalPricePerUnit: 225,
                    refundAmount: 450,
                    _id: '68c2a6b78667d4d21d661f2a'
                  }
                ],
                totalAmount: 450,
                wasteCost: 0,
                reasonType: 'change_mind',
                createdBy: {
                  _id: '68ab4b0775017ad6d7d8ad76',
                  username: 'tc1',
                  role: 'cashier'
                },
                createdAt: '2025-09-11T10:38:47.891Z',
                updatedAt: '2025-09-11T10:38:47.891Z'
              },
              {
                _id: '68d34143941bc92c1fdbb3b7',
                order: {
                  _id: '68d34094941bc92c1fdbb343',
                  orderNumber: 'ORD94892263001',
                  branch: {
                    _id: '68ab4a5075017ad6d7d8ad53',
                    name: 'Tezlaa Colombo',
                    type: 'outlet',
                    address: 'Colombo 5'
                  },
                  customer: {
                    _id: '68ac4a2433f0e932f040a32c',
                    name: 'Walking Customer',
                    mobileNumber: '0000000000'
                  },
                  orderType: 'dine_in',
                  orderStatus: 'completed',
                  paymentStatus: 'paid'
                },
                branch: '68ab4a5075017ad6d7d8ad53',
                returnType: 'customer',
                restockableStatus: true,
                refundMethod: 'cash',
                items: [
                  {
                    product: {
                      _id: '68ab4e4475017ad6d7d8af76',
                      name: 'Blueberry Muffin',
                      sku: 'PC001',
                      cost: 125,
                      outletPrice: 250
                    },
                    returnQuantity: 1,
                    unitPrice: 250,
                    discountPerUnit: 0,
                    finalPricePerUnit: 250,
                    refundAmount: 250,
                    _id: '68d34143941bc92c1fdbb3b8'
                  }
                ],
                totalAmount: 250,
                wasteCost: 0,
                reasonType: 'change_mind',
                createdBy: {
                  _id: '68ab4b2375017ad6d7d8ad82',
                  username: 'admin',
                  role: 'admin'
                },
                createdAt: '2025-09-24T00:54:27.704Z',
                updatedAt: '2025-09-24T00:54:27.704Z'
              },
              {
                _id: '68d4acc8faef3bb6b3de764a',
                order: {
                  _id: '68d4ab5cfaef3bb6b3de7317',
                  orderNumber: 'ORD87764364001',
                  branch: {
                    _id: '68ab4a5075017ad6d7d8ad53',
                    name: 'Tezlaa Colombo',
                    type: 'outlet',
                    address: 'Colombo 5'
                  },
                  customer: {
                    _id: '68ac4a2433f0e932f040a32c',
                    name: 'Walking Customer',
                    mobileNumber: '0000000000'
                  },
                  orderType: 'take_away',
                  orderStatus: 'completed',
                  paymentStatus: 'paid'
                },
                branch: '68ab4a5075017ad6d7d8ad53',
                returnType: 'customer',
                restockableStatus: true,
                refundMethod: 'cash',
                items: [
                  {
                    product: {
                      _id: '68ab4e4475017ad6d7d8af76',
                      name: 'Blueberry Muffin',
                      sku: 'PC001',
                      cost: 125,
                      outletPrice: 250
                    },
                    returnQuantity: 1,
                    unitPrice: 250,
                    discountPerUnit: 25,
                    finalPricePerUnit: 225,
                    refundAmount: 225,
                    _id: '68d4acc8faef3bb6b3de764b'
                  }
                ],
                totalAmount: 225,
                wasteCost: 0,
                reasonType: 'change_mind',
                createdBy: {
                  _id: '68ab4b2375017ad6d7d8ad82',
                  username: 'admin',
                  role: 'admin'
                },
                createdAt: '2025-09-25T02:45:28.290Z',
                updatedAt: '2025-09-25T02:45:28.290Z'
              }
            ],
            totalResults: 3
          }
        }
      }
      
      throw error
    }
  }

  /**
   * Get customer return by ID
   * @param {string} id - Return ID
   * @returns {Promise} API response
   */
  async getCustomerReturnById(id) {
    try {
      console.log('📋 Fetching customer return by ID:', id)
      
      const response = await ApiService.get(`/order-returns/${id}`)
      console.log('✅ Customer return fetched successfully:', response)
      return response
    } catch (error) {
      console.error('❌ Error fetching customer return by ID:', error)
      
      // Return mock data if API is not available
      if (error.response?.status === 404 || error.message?.includes('Network Error')) {
        console.warn('Customer return API not available, returning mock data')
        return {
          success: true,
          statusCode: 200,
          message: 'Order return retrieved successfully (mock data)',
          data: {
            orderReturn: {
              _id: id,
              order: {
                _id: '68c2a6168667d4d21d661dd6',
                orderNumber: 'ORD06766737001',
                branch: {
                  _id: '68ab4a5075017ad6d7d8ad53',
                  name: 'Tezlaa Colombo',
                  type: 'outlet',
                  address: 'Colombo 5'
                },
                customer: {
                  _id: '68ac4a2433f0e932f040a32c',
                  name: 'Walking Customer',
                  mobileNumber: '0000000000'
                },
                orderType: 'dine_in',
                orderStatus: 'completed'
              },
              branch: '68ab4a5075017ad6d7d8ad53',
              returnType: 'customer',
              restockableStatus: true,
              refundMethod: 'cash',
              items: [
                {
                  product: {
                    _id: '68ab4e4475017ad6d7d8af76',
                    name: 'Blueberry Muffin',
                    sku: 'PC001',
                    cost: 125,
                    outletPrice: 250
                  },
                  returnQuantity: 2,
                  unitPrice: 250,
                  discountPerUnit: 25,
                  finalPricePerUnit: 225,
                  refundAmount: 450
                }
              ],
              totalAmount: 450,
              wasteCost: 0,
              reasonType: 'change_mind',
              createdBy: {
                _id: '68ab4b0775017ad6d7d8ad76',
                username: 'tc1',
                role: 'cashier'
              },
              createdAt: '2025-09-11T10:38:47.891Z',
              updatedAt: '2025-09-11T10:38:47.891Z'
            }
          }
        }
      }
      
      throw error
    }
  }
}

export default new CustomerReturnService()